import React, { useMemo, useReducer } from 'react';
import Context from './context';
import { UpcomingType } from './types';
const initialState = {
    regularCampaigns: {},
    earlyCampaigns: {},
};
const upcomingReducer = (state, { type, payload }) => {
    switch (type) {
        case UpcomingType.SET_REGULAR: {
            return { ...state, regularCampaigns: payload };
        }
        case UpcomingType.SET_EARLY_ACCESS: {
            return { ...state, earlyCampaigns: payload };
        }
        case UpcomingType.ADD_REGULAR: {
            return {
                ...state,
                regularCampaigns: {
                    ...state.regularCampaigns,
                    ...payload,
                },
            };
        }
        case UpcomingType.ADD_EARLY_ACCESS: {
            return {
                ...state,
                earlyCampaigns: {
                    ...state.earlyCampaigns,
                    ...payload,
                },
            };
        }
        default: {
            throw new Error(`Unhandled action type "${type}" in UpcomingProvider.`);
        }
    }
};
const UpcomingProvider = ({ children }) => {
    const [state, dispatch] = useReducer(upcomingReducer, initialState);
    const context = useMemo(() => ({ ...state, dispatch }), [state]);
    return React.createElement(Context.Provider, { value: context }, children);
};
export default UpcomingProvider;
//# sourceMappingURL=upcoming-provider.js.map